export enum WidgetDisplayType {
  None = 0,
  Bar = 1,
  Line = 2,
  Gauge = 3,
  Pie = 4,
  Area = 5
}
